import { CheckIcon } from "lucide-react";
import mascot from "../images/Mascot-peace.png";

export default function HeroSection() {
  return (
    <section className="py-8 md:py-20">
      <div className="max-w-7xl mx-auto px-6 py-6 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 items-center">
        <div className="flex justify-center md:justify-end order-first md:order-last w-11/12 sm:w-3/4 md:w-auto">
          <div className="p-4 md:p-8 max-w-sm">
            <img
              src={mascot}
              alt="Bookshelf Mascot"
              className="w-full h-auto max-h-48 md:max-h-none"
            />
          </div>
        </div>

        <div className="space-y-6 order-last md:order-first">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
            Your Reading Life, All in One Cozy Place.
          </h1>

          <p className="text-lg text-gray-600 leading-relaxed max-w-md">
            Track your books, discover stories by mood, and share your reading
            journey with a community that loves books as much as you do.
          </p>

          <div className="flex gap-4">
            <p className="border-2 border-gray-300 text-gray-600 bg-white px-3 py-2 rounded-3xl text-sm">
              <CheckIcon className="inline-block text-green-500 mr-2" />
              Ad-free forever
            </p>
            <p className="border-2 border-gray-300 text-gray-600 bg-white px-3 py-2 rounded-3xl text-sm">
              <CheckIcon className="inline-block text-green-500 mr-2" />
              Privacy focused
            </p>
          </div>

          <div className="flex gap-4 pt-4">
            <a href="#beta-list" className="bg-accent hover:bg-primary-light text-white font-semibold px-8 py-3 rounded-lg transition">
              Join the Beta Waitlist
            </a>
            <a href="#vision" className="border-2 border-gray-300 text-gray-700 hover:border-primary-light hover:text-primary-light font-semibold px-8 py-3 rounded-lg transition">
              Explore the Vision
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
